"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreYouPatientPopUp = void 0;
const react_1 = __importStar(require("react"));
const AreYouPatientPopUp_elements_1 = require("./AreYouPatientPopUp.elements");
const PopUp_1 = require("@components/common/PopUp");
const Landing_1 = require("@app/routes/Landing");
const AreYouPatient_translations_1 = require("./AreYouPatient.translations");
const AreYouPatientPopUp = ({ onClose, openPatientLanding, openTherapistLanding, }) => {
    const language = (0, react_1.useContext)(Landing_1.LanguageContext);
    const t = AreYouPatient_translations_1.translations[language];
    return (react_1.default.createElement(PopUp_1.PopUp, { title: "", onClose: onClose },
        react_1.default.createElement(AreYouPatientPopUp_elements_1.AreYouPatientContent, null,
            react_1.default.createElement("h1", null, t.h1),
            react_1.default.createElement("div", { className: "are-you-patient-buttons" },
                react_1.default.createElement("button", { onClick: openPatientLanding }, t.buttons["1"]),
                react_1.default.createElement("button", { onClick: openTherapistLanding }, t.buttons["2"])))));
};
exports.AreYouPatientPopUp = AreYouPatientPopUp;
